'use client';

import { Button, message } from 'antd';

import TitleDescription from '@/components/title-description';
import { useTranslation } from '@/i18n/client';
import { fetchBillingUrl } from '@/service/subscription';
import { ROUTER_PATH } from '@/utils/router';

import styles from './index.less';

export interface StripeBillingEntryProps {
  className?: string;
}

export const StripeBillingEntry = (props: StripeBillingEntryProps): JSX.Element => {
  const { className } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const { t } = useTranslation();

  const handleGoStripeLink = () => {
    fetchBillingUrl(`${window.location.origin}${ROUTER_PATH.personalAI}`)
      .then((res) => {
        if (res.data.code !== 0) {
          messageApi.error(res.data.message ?? '');
        }

        if (res.data.data) {
          window.open(res.data.data);
        }
      })
      .catch((error) => {
        messageApi.error(error);
      });
  };

  return (
    <div className={className}>
      <TitleDescription
        desc={t('menu.subscriptionModal.billingTip')}
        title={t('menu.subscriptionModal.billing')}
      />
      <div className={styles.actionButtons}>
        <Button
          onClick={() => {
            handleGoStripeLink();
          }}
          type="primary"
        >
          {t('menu.subscriptionModal.manageBilling')}
        </Button>
      </div>
      {contextHolder}
    </div>
  );
};
